<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-cross-sell-item-section"
    full-width
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <zg-grid
      v-if="itemsToShow && itemsToShow.length"
      :columns="1"
      :m-columns="6"
      :l-columns="6"
      class="grid"
    >
      <zg-tile
        v-for="(item, index) in itemsToShow"
        :key="`cross-sell-item-${index}`"
        :product="item.product"
        :href="item.href"
        :text="item.text"
        :tag="item.tag"
        :disabled="item.disabled"
        full-width-mobile
        @click.native="$emit('click')"
      />
    </zg-grid>

    <zg-flex
      v-if="items && items.length > 6 && (showLessText && showMoreText)"
      justify-content="center"
      class="show-more"
    >
      <zg-link-button
        v-if="items && items.length > 6"
        link="#"
        :icons="{ right: showMore ? 'compress' : 'expand' }"
        @click.prevent.native="getItems()"
      >
        {{ showMore ? showLessText : showMoreText }}
      </zg-link-button>
    </zg-flex>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgFlex from '../../layout/flex/ZgFlex'
  import ZgGrid from '../../layout/grid/ZgGrid.vue'
  import ZgLinkButton from '../../ZgLinkButton/ZgLinkButton.vue'
  import ZgTile from '../../ZgTile/ZgTile'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgCrossSellItemSection',
    components: {
      ZgFlex,
      ZgGrid,
      ZgLinkButton,
      ZgTile,
      ZgModule
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      showMoreText: {
        type: String,
        required: false,
        default: ''
      },
      showLessText: {
        type: String,
        required: false,
        default: ''
      },
      showMoreDefault: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      showMore: false,
      itemsToShow: 0
    }),
    created () {
      this.itemsToShow = this.items.slice(0, 6)
    },
    mounted () {
      if (document.location.search?.includes('show-all-products')) this.getItems()
      else if (this.showMoreDefault) this.getItems()
    },
    methods: {
      getItems () {
        this.showMore = !this.showMore
        this.itemsToShow = this.showMore ? this.items : this.items.slice(0, 6)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .grid {
    gap: rhythm(small);

    @include mq(medium) {
      gap: rhythm(base)
    }
  }

  .show-more {
    margin: rhythm(medium) 0 0;
  }

  a {
    display: inline-flex;
    justify-content: center;
  }
</style>
